import type { Payment } from '../interfaces';

export const getGiftCardPayment = (payments?: Payment[]) => {
  const giftCard = payments?.find(
    (payment) => payment.paymentMethodInfo.method === 'giftCard'
  );
  return giftCard;
};

const getInterfaceInteractions = (payment: Payment) => {
  return payment?.interfaceInteractions?.find((interaction) => interaction);
};

const getGiftCardDetails = (payment: Payment) => {
  const interfaceInteractions = getInterfaceInteractions(payment);

  return interfaceInteractions?.giftCardDetails;
};

const getGiftCardBalance = (payment: Payment) => {
  if (!payment) return 0;
  const giftCardDetails = getGiftCardDetails(payment);
  const balance = giftCardDetails?.balance ?? 0;
  return balance;
};

const getGiftCardAmount = (payment: Payment) => {
  if (!payment) return 0;
  let amount: number = 0;
  const giftCardDetails = getGiftCardDetails(payment);
  giftCardDetails?.details?.map((detail) => {
    amount += detail.amount;
  });
  return amount;
};

export const canGiftCardPayTotalAmount = (
  payment?: Payment,
  othersPaymentTotalAmount: number = 0
) => {
  if (!payment) return false;

  const amount = getGiftCardAmount(payment);

  if (amount === 0) {
    return false;
  }

  const balance = getGiftCardBalance(payment);
  if (balance <= 0) {
    return false;
  }

  return amount >= othersPaymentTotalAmount;
};

export const getGiftCardCanPayTotalAmount = (
  payments?: Payment[],
  othersPaymentTotalAmount?: number
) => {
  const giftCard = getGiftCardPayment(payments);

  return canGiftCardPayTotalAmount(giftCard, othersPaymentTotalAmount);
};
